module.exports = __webpack_public_path__ + "img/xpress.fbcb8c21.svg";